var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboardingSurvey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 350,
    viewBox: "0 0 500 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mother told story to her daughter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 94",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.767 34.9198C353.102 36.3638 362.649 61.2756 378.656 74.8059C394.663 88.3362 393.378 92.9405 398.485 96.982C403.592 101.023 410.505 100.011 410.505 100.011C410.505 100.011 390.432 33.4759 371.767 34.9198Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 94 Copy 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.767 86.1402C353.102 87.5841 362.649 112.496 378.656 126.026C394.663 139.557 393.378 144.161 398.485 148.202C403.592 152.244 410.505 151.231 410.505 151.231C410.505 151.231 390.432 84.6962 371.767 86.1402Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 96 Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.631 226.711C422.548 216.05 437.37 167.573 452.724 150.018C468.079 132.464 486.903 135.818 480.011 158.361C473.119 180.903 460.418 178.51 454.341 198.387C448.264 218.264 414.714 237.372 418.631 226.711Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 94 Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.407 77.2419C492.728 79.1347 480.287 111.791 459.43 129.528C438.573 147.265 446.837 153.484 433.084 162.569H417.93C417.93 162.569 444.086 75.3491 468.407 77.2419Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 96",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.618 100.14C425.248 88.799 425.248 38.1063 434.799 16.8296C444.35 -4.44716 463.332 -6.74319 463.332 16.8296C463.332 40.4023 450.487 41.8271 450.487 62.6121C450.487 83.3972 423.989 111.48 424.618 100.14Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 101",
    d: "M421.686 118.772C421.686 117.031 442.816 15.7578 451.56 1.90704",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 102",
    d: "M415.106 112.009C413.474 112.009 407.435 81.569 372.047 41.738",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 103",
    d: "M393.576 122.384C391.575 119.125 372.047 89.0788 372.047 89.0788",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 104",
    d: "M434.189 140.546C434.189 140.546 445.011 105.344 470.757 80.1709",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 105",
    d: "M454.426 176.406C454.426 176.406 465.06 150.257 474.179 141.896",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.101 321.337C32.1918 321.227 39.1596 320.98 51.3937 320.548C58.3571 320.303 63.9291 320.128 69.3247 319.995C87.6989 319.542 100.913 319.682 108.936 320.626C113.426 321.155 116.094 321.959 116.544 322.79C116.873 323.4 115.348 324.72 111.362 326.463C91.9528 325.179 73.1608 326.803 61.3674 330.764C44.6423 328.751 32.0998 325.991 28.9507 322.471C28.5958 322.075 28.3137 321.697 28.101 321.337ZM27.6025 319.862C27.3132 314.174 48.906 314.174 70.8334 314.174H147.058C146.059 315.383 146.912 317.496 149.321 320.414C156.118 328.645 173.895 335.413 204.335 343.166C207.481 343.967 210.709 344.768 214.494 345.689C189.153 342.445 174.455 337.848 156.946 335.854C151.495 333.752 146.712 332.251 141.528 330.977C132.856 328.845 123.57 327.435 114.349 326.684C117.446 325.046 118.656 323.576 117.85 322.085C117.059 320.62 114.161 319.746 109.11 319.152C100.994 318.196 87.7333 318.056 69.2887 318.511C63.887 318.644 58.3101 318.819 51.3419 319.065C38.5653 319.515 31.5692 319.761 27.6025 319.862ZM156.398 314.174H219.966C217.862 316.866 217.055 319.851 217.878 322.679C219.047 326.694 226.559 328.921 242.923 331.589C244.354 331.822 250.947 332.865 252.653 333.146C260.428 334.428 264.569 335.408 266.269 336.534C266.979 337.004 267.019 337.225 266.515 337.724C265.701 338.529 263.722 339.496 260.524 340.59C251.437 343.697 234.134 340.308 207.801 331.582C204.078 330.348 200.174 329.01 195.783 327.47C191.927 326.118 177.55 320.984 174.335 319.859C166.788 317.217 161.569 315.526 157.484 314.452C157.111 314.354 156.749 314.261 156.398 314.174V314.174ZM221.91 314.174H246.219C253.697 314.174 264.058 314.174 276.262 314.192C284.817 318.592 287.012 324 284.662 330.93C283.674 333.843 282.084 336.696 279.245 341.018C276.403 345.342 274.921 347.623 274.078 349.212C254.768 349.112 239.253 348.257 226.3 347.01C222.879 346.186 218.76 345.196 217.92 344.993C212.748 343.743 208.658 342.735 204.7 341.727C174.631 334.069 156.968 327.344 150.465 319.469C148.123 316.633 147.745 315.268 148.53 314.893C149.641 314.361 152.549 314.689 157.105 315.887C161.143 316.95 166.332 318.631 173.844 321.26C177.054 322.383 191.43 327.517 195.291 328.871C199.69 330.414 203.601 331.754 207.333 332.991C234.019 341.834 251.474 345.253 261.003 341.995C264.403 340.832 266.538 339.789 267.558 338.78C268.779 337.572 268.537 336.256 267.088 335.296C265.129 333.999 260.945 333.009 252.894 331.682C251.182 331.399 244.587 330.356 243.161 330.123C227.793 327.618 220.207 325.369 219.303 322.264C218.538 319.635 219.52 316.749 221.91 314.174V314.174ZM279.272 314.197C289.222 314.214 300.287 314.243 311.942 314.294C321.364 320.048 322.129 330.113 315.132 340.875C313.284 343.717 311.053 346.343 308.567 348.666C307.336 348.709 306.1 348.75 304.86 348.788C294.299 349.112 284.644 349.244 275.778 349.219C276.637 347.712 278.048 345.544 280.486 341.833C283.391 337.411 285.029 334.473 286.069 331.407C288.429 324.447 286.553 318.747 279.272 314.197ZM314.599 314.305C325.908 314.358 337.728 314.43 349.589 314.532C351.364 316.603 351.277 318.891 349.201 321.452C345.255 326.318 343.036 329.555 342.171 331.775C341.184 334.308 341.914 335.928 344.278 336.399C346.087 336.76 348.877 336.52 353.75 335.698C355.372 335.425 366.067 333.452 369.77 332.827C370.577 332.691 371.374 332.559 372.166 332.431C380.297 331.115 390.659 327.805 415.171 319.195L415.524 319.07C418.997 317.85 422.15 316.748 425.026 315.749C437.697 316.106 448.622 316.544 456.745 317.082C445.494 325.239 425.312 332.194 400.659 336.912C374.093 341.996 346.725 343.489 334.508 340.57C325.91 338.516 321.293 340.269 321.293 345.961C321.293 346.626 321.359 347.346 321.491 348.121C317.962 348.296 314.392 348.451 310.783 348.586C312.876 346.479 314.766 344.161 316.376 341.684C323.324 330.999 322.987 320.68 314.599 314.305ZM351.436 314.548C375.864 314.763 400.363 315.102 420.84 315.635C419.009 316.275 417.077 316.952 415.033 317.67L414.68 317.794C390.282 326.364 379.934 329.671 371.931 330.965C371.135 331.094 370.335 331.226 369.524 331.363C365.807 331.99 355.112 333.963 353.505 334.234C348.82 335.024 346.134 335.255 344.569 334.943C343.17 334.664 342.886 334.034 343.556 332.314C344.348 330.283 346.505 327.136 350.356 322.387C352.656 319.55 352.923 316.904 351.436 314.548ZM458.999 317.239C463.918 317.601 467.614 318.005 469.797 318.457C489.327 322.499 422.636 342.938 322.983 348.046C322.846 347.29 322.777 346.595 322.777 345.961C322.777 341.51 326.36 340.15 334.162 342.014C346.632 344.994 374.182 343.491 400.938 338.37C426.801 333.421 447.79 326.038 458.999 317.239ZM151.057 335.297C147.427 335.024 143.629 334.871 139.556 334.869C126.595 334.86 112.213 334.494 98.207 333.765C104.349 331.118 110.815 328.318 111.568 327.992C121.582 328.662 131.757 330.105 141.172 332.419C144.534 333.245 147.729 334.169 151.057 335.297ZM94.8757 333.584C84.3134 332.988 74.0493 332.183 64.8663 331.167C75.7654 328.239 91.6589 326.962 108.279 327.799C105.052 329.195 99.5703 331.565 94.8757 333.584Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 28 Copy 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.587 221.955L117.288 317.625C117.218 318.883 118.219 319.941 119.479 319.941C120.606 319.941 121.549 319.089 121.663 317.968L131.39 221.955H122.587Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 28 Copy 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.129 221.955L63.8231 317.622C63.7532 318.882 64.7558 319.941 66.0173 319.941C67.1452 319.941 68.0899 319.088 68.2037 317.966L77.9441 221.955H69.129Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 28 Copy 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.853 262.783L449.069 316.009C449.198 317.32 448.167 318.457 446.849 318.457C445.769 318.457 444.844 317.683 444.654 316.62L435.003 262.783H443.853Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.372 262.783L398.589 316.009C398.717 317.32 397.687 318.457 396.369 318.457C395.289 318.457 394.364 317.683 394.173 316.62L384.522 262.783H393.372Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5957 297.301C87.5957 295.866 88.7589 294.702 90.1938 294.702H453.932C455.367 294.702 456.53 295.866 456.53 297.301C456.53 298.735 455.367 299.899 453.932 299.899H90.1938C88.7589 299.899 87.5957 298.735 87.5957 297.301Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6426 297.301C58.6426 295.866 59.8058 294.702 61.2407 294.702H384.151C385.586 294.702 386.75 295.866 386.75 297.301C386.75 298.735 385.586 299.899 384.151 299.899H61.2407C59.8058 299.899 58.6426 298.735 58.6426 297.301Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5273 162.569L461.889 163.348C484.758 163.389 501.793 184.464 497.039 206.833L483.963 268.352C480.423 285.007 465.7 296.904 448.674 296.868L71.0428 296.071L21.5273 162.569Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.453 145.122C125.453 125.239 141.571 109.122 161.453 109.122H399.002C418.884 109.122 435.002 125.239 435.002 145.122V237.544H125.453V145.122Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3984 145.122C82.3984 125.239 98.5162 109.122 118.398 109.122H363.371C383.253 109.122 399.371 125.239 399.371 145.122V237.544H82.3984V145.122Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3979 296.187L52.7142 180.337C50.0352 169.881 40.6128 162.569 29.8191 162.569C14.5853 162.569 3.3303 176.769 6.80868 191.6L25.4326 271.01C28.8917 285.759 42.048 296.187 57.1972 296.187H82.3979Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7363 250.163C49.7363 240.324 57.7127 232.347 67.5521 232.347H380.813C390.652 232.347 398.628 240.324 398.628 250.163C398.628 260.002 390.652 267.979 380.813 267.979H67.5521C57.7127 267.979 49.7363 260.002 49.7363 250.163Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 25 Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.131 296.929L403.831 180.372C406.499 169.899 415.931 162.569 426.74 162.569C441.965 162.569 453.221 176.752 449.763 191.579L431.108 271.561C427.643 286.418 414.398 296.929 399.142 296.929H374.131Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.092 198.2C433.062 198.2 438.712 192.55 438.712 185.581C438.712 178.611 433.062 172.961 426.092 172.961C419.123 172.961 413.473 178.611 413.473 185.581C413.473 192.55 419.123 198.2 426.092 198.2Z",
    fill: "#FFDC84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9496 198.2C35.9191 198.2 41.5691 192.55 41.5691 185.581C41.5691 178.611 35.9191 172.961 28.9496 172.961C21.98 172.961 16.3301 178.611 16.3301 185.581C16.3301 192.55 21.98 198.2 28.9496 198.2Z",
    fill: "#FFDC84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 380",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.277 73.2604C106.277 73.2604 102.437 76.2786 102.437 79.5227C102.437 82.7669 105.184 86.4262 106.891 86.8467C105.092 90.6471 101.578 103.23 101.578 103.23L114.186 107.359L119.335 97.9867C119.335 97.9867 126.934 98.8824 129.532 93.8563C132.13 88.8302 132.13 67.6625 132.13 67.6625L118.129 65.1857L106.277 73.2604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path 58"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.773 97.9867L117.288 112.833L118.03 128.725L102.441 104.498",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.773 97.9867L117.288 112.833L118.03 128.725L102.441 104.498",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 10",
    d: "M132.133 68.2938C132.133 68.2938 131.77 78.1847 130.812 88.5904C129.854 98.9961 122.405 99.0428 116.764 96.8033C111.123 94.5637 109.863 90.7404 109.863 90.7404",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 145",
    d: "M126.938 80.5296C126.938 80.917 128.407 85.5502 129.164 86.1096C129.922 86.6689 126.938 86.8467 126.938 86.8467",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 146",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.288 90.069C127.288 90.069 121.374 87.8594 122.087 90.2428C122.8 92.6262 125.175 92.66 126.229 92.1285C127.282 91.597 127.288 90.069 127.288 90.069Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 60",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.935 70.0514C132.347 69.3228 136.888 65.7707 135.621 60.4369C134.354 55.103 127.279 53.9156 127.279 53.9156C127.279 53.9156 98.2735 51.3325 96.0269 62.9981C95.1157 67.7294 95.4328 71.7313 96.9782 75.0038C91.7653 71.9292 80.6788 74.3579 83.6303 87.1897C86.5818 100.022 96.9782 98.4523 100.765 94.0694C101.383 93.3545 103.958 90.675 103.714 85.1358C103.652 83.7343 101.49 80.417 101.49 80.417C101.49 80.417 103.268 77.5986 106.984 79.0078C106.984 79.0078 117.713 76.1231 125.379 66.9321C123.793 73.5704 131.523 70.78 131.935 70.0514Z",
    fill: "#FF9B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 59",
    d: "M106.895 78.5707C106.895 78.5707 102.441 76.7257 102.441 80.3126C102.441 83.8995 105.171 86.1096 106.895 86.1096C105.637 89.3171 102.441 100.625 102.441 100.625",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval Copy_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.893 88.3365C108.123 88.3365 109.12 87.3395 109.12 86.1095C109.12 84.8796 108.123 83.8826 106.893 83.8826C105.663 83.8826 104.666 84.8796 104.666 86.1095C104.666 87.3395 105.663 88.3365 106.893 88.3365Z",
    fill: "#FFDC84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 61",
    d: "M123.967 68.2938C123.967 68.2938 128.435 64.5551 129.163 60.8706",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 61 Copy",
    d: "M126.938 70.5208C126.938 70.5208 131.406 66.7821 132.134 63.0975",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 70 Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.02 202.654C174.02 202.654 194.609 209.669 198.631 219.728C202.654 229.786 171.659 304.191 171.659 304.191C171.659 304.191 170.59 307.794 173.778 309.727C175.733 310.912 176.782 313.071 183.969 315.563C186.139 316.315 188.76 315.9 189.64 316.537C191.675 318.009 191.178 320.435 186.014 320.435C178.614 320.435 155.705 320.435 155.705 320.435C155.705 320.435 156.943 316.589 158.484 309.727C162.394 292.326 167.565 241.603 174.02 230.423H148.463L174.02 202.654Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 70",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.145 206.746C162.145 206.746 179.838 210.334 186.756 221.212C190.083 226.442 185.797 242.833 174.973 269.806C170.788 280.234 159.784 305.676 159.784 305.676C159.784 305.676 158.477 308.452 162.259 311.212C163.344 312.004 167.604 314.174 174.973 317.853C175.212 317.972 175.453 318.055 175.689 318.109C176.815 318.368 178.131 319.193 178.131 320.349C178.131 321.216 177.429 321.919 176.562 321.919H146.926C145.396 321.919 144.289 320.425 144.694 318.949C145.191 317.136 145.865 314.526 146.609 311.212C150.519 293.81 155.69 243.088 162.145 231.908H136.588L162.145 206.746Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 106",
    d: "M149.917 309.996C149.917 309.996 149.641 312.955 152.477 314.174",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 69",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4275 172.961L75.1054 198.351C73.9146 205.346 75.3196 212.535 79.0562 218.566C84.3637 227.134 93.7253 232.347 103.804 232.347H153.701C153.701 232.347 166.365 205.877 179.745 205.877C193.125 205.877 128.421 175.491 128.421 175.491L79.4275 172.961Z",
    fill: "#1D70D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 111",
    d: "M84.5859 172.292C84.5859 172.292 78.6097 215.388 100.174 220.816C121.739 226.244 157.472 227.501 157.472 227.501",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 62",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.272 103.23L116.989 124.383C116.989 124.383 116.779 117.365 116.989 113.356C117.198 109.347 118.027 104.498 118.027 104.498C118.027 104.498 139.065 109.595 142.836 116.611C146.607 123.628 150.32 141.954 150.32 141.954L157.429 128.725C157.429 128.725 162.525 138.711 166.955 137.982C171.384 137.252 168.122 132.575 168.122 132.575C168.122 132.575 173.472 134.017 170.213 141.954C166.955 149.891 162.196 166.697 150.32 171.037C138.443 175.377 135.307 154.374 135.307 154.374L128.42 175.491L79.4977 173.333L82.3959 144.407C82.3959 144.407 73.2276 128.725 79.4977 116.611C85.7679 104.498 104.272 103.23 104.272 103.23Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 65"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.74 122.35C121.74 122.35 132.548 107.365 135.168 103.23C137.789 99.0953 147.705 93.3043 147.705 93.3043L149.301 95.608L143.238 101.699C143.238 101.699 146.863 104.887 145.688 109.122C144.513 113.356 136.587 116.873 136.587 116.873L129.906 132.341",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.74 122.35C121.74 122.35 132.548 107.365 135.168 103.23C137.789 99.0953 147.705 93.3043 147.705 93.3043L149.301 95.608L143.238 101.699C143.238 101.699 146.863 104.887 145.688 109.122C144.513 113.356 136.587 116.873 136.587 116.873L129.906 132.341",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 66"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.269 119.5C140.409 119.5 135.168 120.404 135.168 120.404L144.555 85.5323C144.555 85.5323 163.021 72.9176 175.203 89.0788",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.269 119.5C140.409 119.5 135.168 120.404 135.168 120.404C135.168 120.404 144.555 85.5323 144.555 85.5323C144.555 85.5323 163.021 72.9176 175.203 89.0788",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 67"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.205 89.0789C175.205 89.0789 177.138 76.7091 191.034 77.944L188.323 86.1096",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.205 89.0789C175.205 89.0789 177.138 76.7091 191.034 77.944L188.323 86.1096",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 64",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.973 88.9939C175.973 88.9939 160.34 76.9846 146.607 88.9939L137.787 123.492C137.787 123.492 152.709 118.295 157.472 126.498C162.236 134.701 163.884 129.512 163.884 129.512C163.884 129.512 175.467 120.841 178.982 126.498L194.608 83.8826C194.608 83.8826 187.669 79.4369 182.808 81.6556C177.947 83.8743 175.973 88.9939 175.973 88.9939Z",
    fill: "#0ACC94"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path 63"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.473 129.654C157.473 129.654 161.735 119.913 161.735 118.565C160.588 113.282 163.747 111.383 164.944 105.943L165.524 98.9946C165.6 98.0823 166.482 97.4607 167.367 97.6961C168.011 97.8675 168.459 98.4505 168.459 99.1169V105.943L170.236 102.684L172.948 94.23C173.156 93.5812 173.814 93.1879 174.484 93.3116C175.23 93.4493 175.717 94.1721 175.565 94.915L173.312 105.943L177.974 94.5105C178.293 93.727 179.184 93.3475 179.971 93.6604C180.715 93.9566 181.108 94.7736 180.876 95.5402L177.332 107.21L182.053 97.4152C182.389 96.7197 183.21 96.4084 183.922 96.7068C184.639 97.0074 184.992 97.8196 184.722 98.5489L181.287 107.835C181.287 107.835 179.576 110.618 179.35 111.551C178.92 113.327 178.951 113.623 178.551 114.621C177.635 116.903 174.554 119.926 174.554 119.926C174.554 119.926 167.998 132.974 166.578 136.928",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.473 129.654C157.473 129.654 161.735 119.913 161.735 118.565C160.588 113.282 163.747 111.383 164.944 105.943L165.524 98.9946C165.6 98.0823 166.482 97.4607 167.367 97.6961V97.6961C168.011 97.8675 168.459 98.4505 168.459 99.1169V105.943L170.236 102.684L172.948 94.23C173.156 93.5812 173.814 93.1879 174.484 93.3116V93.3116C175.23 93.4493 175.717 94.1721 175.565 94.915L173.312 105.943L177.974 94.5105C178.293 93.727 179.184 93.3475 179.971 93.6604V93.6604C180.715 93.9566 181.108 94.7736 180.876 95.5402L177.332 107.21L182.053 97.4152C182.389 96.7197 183.21 96.4084 183.922 96.7068V96.7068C184.639 97.0074 184.992 97.8196 184.722 98.5489L181.287 107.835C181.287 107.835 179.576 110.618 179.35 111.551C178.92 113.327 178.951 113.623 178.551 114.621C177.635 116.903 174.554 119.926 174.554 119.926C174.554 119.926 167.998 132.974 166.578 136.928",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 68",
    d: "M93.1615 120.404L110.606 145.985L121.741 122.35C121.741 122.35 128.09 133.072 131.801 133.072C135.513 133.072 132.876 129.668 132.876 129.668C132.876 129.668 137.462 132.444 135.169 139.361C132.876 146.277 127.615 165.056 117.366 169.071C107.118 173.087 84.5879 147.391 84.5879 147.391",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 89",
    d: "M135.91 153.908C135.91 153.908 142.283 149.592 141.189 133.439",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 71",
    d: "M172.498 172.994C172.498 172.994 174.693 176.014 176.936 176.852C179.179 177.69 182.158 177.733 182.326 178.642C182.495 179.552 181.374 180.725 181.374 180.725C181.374 180.725 185.503 184.863 186.133 187.74C186.763 190.617 181.969 195.283 181.969 195.283L186.763 199.466",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 146_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.907 184.559C181.907 184.559 177.643 189.214 180.119 189.447C182.596 189.679 183.518 187.489 183.419 186.313C183.321 185.137 181.907 184.559 181.907 184.559Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 74",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.683 196.629L178.432 211.034L183.117 214.532C183.117 214.532 182.08 225.757 196.552 229.052C211.024 232.347 236.393 232.347 242.276 232.347C248.159 232.347 254.664 232.347 254.664 232.347C254.664 232.347 250.161 215.842 250.161 196.629C244.554 196.028 237.932 196.865 228.465 196.629C221.536 196.456 211.283 195.079 207.796 195.079C195.231 195.079 189.622 197.356 189.622 197.356L185.683 196.629Z",
    fill: "#FFDC84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 80",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.316 216.022C372.316 216.022 377.883 215.993 382.693 209.853C384.767 207.206 387.627 202.661 388.703 199.979C390.122 196.439 389.599 195.079 391.574 195.079C395.047 195.079 395.585 197.964 393.575 204.465C391.565 210.967 393.888 229.992 388.703 232.347C383.517 234.703 380.343 229.726 369.098 229.726C357.854 229.726 372.316 216.022 372.316 216.022Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 76",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.094 206.746L322.112 202.654L374.129 213.713L370.185 232.347C370.185 232.347 335.591 229.726 316.518 229.726C297.445 229.726 258.906 232.347 258.906 232.347L270.094 206.746Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 109",
    d: "M273.477 222.474C273.477 222.474 306.933 219.442 330.248 221.955C353.564 224.468 364.18 226.244 364.18 226.244",
    stroke: "#D6DCFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 99",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.721 213.054C310.721 213.054 312.892 218.703 312.892 224.618C312.859 227.186 311.204 230.874 315.419 232.347C317.38 233.033 341.337 232.347 344.32 232.347C348.851 232.347 353.066 227.871 346.021 227.855C339.016 225.122 330.201 221.843 324.912 209.853L310.721 213.054Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path 75"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.16 199.613C250.16 199.613 258.753 186.751 270.406 173.109C278.23 163.95 286.711 152.176 297.597 152.176C310.035 152.176 314.074 164.513 318.349 177.563C323.387 192.946 327.476 209.429 327.476 209.429L306.313 214.679L297.597 185.11C297.597 185.11 274.214 235.116 252.025 232.495",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 199.613C250.16 199.613 258.753 186.751 270.406 173.109C278.23 163.95 286.711 152.176 297.597 152.176C310.035 152.176 314.074 164.513 318.349 177.563C323.387 192.946 327.476 209.429 327.476 209.429C327.476 209.429 306.313 214.679 306.313 214.679L297.597 185.11C297.597 185.11 274.214 235.116 252.025 232.495",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 107",
    d: "M251.6 225.661C262.338 223.786 270.935 217.481 277.391 206.746C288.82 187.74 297.893 168.55 297.893 168.55L309.734 205.992",
    stroke: "#D6DCFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.326 102.493C239.754 95.5964 246.368 93.1047 251.169 95.0175C258.622 97.9868 254.533 105.545 251.169 106.22C249.22 106.611 244.578 107.393 237.243 108.565C242.049 114.311 246.776 122.007 246.776 127.978C246.776 128.093 246.775 128.208 246.773 128.322C248.253 130.468 250.566 142.628 251.207 146.13C251.926 150.066 247.306 151.829 242.256 150.69C239.569 150.084 238.918 144.703 238.841 139.69C235.979 140.179 232.289 139.664 227.688 137.835C226.667 142.218 225.107 147.555 224.478 149.661C223.332 153.495 218.415 152.969 214.433 149.661C211.418 147.157 216.463 137.913 219.093 133.213C214.145 129.49 211.233 124.498 210.359 118.237C205.752 122.538 201.729 125.437 198.288 126.934C192.279 129.548 187.995 120.405 192.33 117.736C195.151 116 201.163 113.223 210.367 109.405C210.464 108.606 210.584 107.793 210.728 106.965C206.294 105.528 202.758 102.099 201.611 97.4957C201.217 95.9166 201.136 94.3276 201.331 92.786C198.763 92.6761 196.716 90.5599 196.716 87.9654C196.716 85.3006 198.876 83.1403 201.541 83.1403C203.017 83.1403 204.338 83.8028 205.223 84.8466C207.162 82.8446 209.718 81.3208 212.694 80.5789C215.93 79.772 219.164 80.0145 221.985 81.0816C221.965 80.9045 221.955 80.7245 221.955 80.5422C221.955 77.8773 224.115 75.7171 226.78 75.7171C229.445 75.7171 231.605 77.8773 231.605 80.5422C231.605 82.8341 230.007 84.7528 227.864 85.2449C229.057 86.6927 229.945 88.4013 230.422 90.3123C231.324 93.9327 230.582 97.6051 228.647 100.638C229.349 100.965 230.27 101.605 231.326 102.493Z",
    fill: "#FF9B6D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path 79"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.967 152.552L231.353 131.941L233.006 122.507L233.768 117.881C233.885 117.169 234.501 116.646 235.223 116.646C236.037 116.646 236.698 117.306 236.698 118.121V124.267L241.624 113.632C241.624 113.632 245.577 121.585 245.577 124.267C245.577 126.948 238.806 134.512 238.806 134.512L236.063 155.393",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.967 152.552L231.353 131.941L233.006 122.507L233.768 117.881C233.885 117.169 234.501 116.646 235.223 116.646V116.646C236.037 116.646 236.698 117.306 236.698 118.121V124.267L241.624 113.632C241.624 113.632 245.577 121.585 245.577 124.267C245.577 126.948 238.806 134.512 238.806 134.512L236.063 155.393",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 73",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.316 164.796C164.555 164.796 167.742 165.101 170.094 167.332C173.465 170.849 173.247 179.894 170.094 174.969C169.783 176.441 169.839 178.396 169.319 180.386C166.651 190.596 187.194 206.857 187.063 206.857C186.931 206.857 176.169 214.532 176.169 214.532C176.169 214.532 165.913 213.493 162.316 210.963C154.958 205.784 149.299 198.2 146.607 190.035C142.258 176.846 157.321 164.796 162.316 164.796Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 77",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.33 204.878L215.485 175.491L224.182 152.176L240.884 156.8C240.884 156.8 235.671 175.652 231.767 185.366C227.862 195.079 209.172 216.022 209.172 216.022",
    fill: "#FFDC84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 78",
    d: "M225.755 196.457L205.379 221.955",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path 82"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.543 125.56L215.436 119.957C215.8 119.251 216.709 119.039 217.348 119.51C217.779 119.829 217.969 120.381 217.824 120.897L216.13 126.934C216.13 126.934 217.703 133.49 216.13 135.838C214.557 138.186 213.503 153.502 213.503 153.502L204.299 152.176L209.242 133.665L210.476 120.039",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.543 125.56L215.436 119.957C215.8 119.251 216.709 119.039 217.348 119.51V119.51C217.779 119.829 217.969 120.381 217.824 120.897L216.13 126.934C216.13 126.934 217.703 133.49 216.13 135.838C214.557 138.186 213.503 153.502 213.503 153.502L204.299 152.176L209.242 133.665L210.476 120.039",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 83",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.402 150.324L197.095 175.838L186.762 200.882L202.152 202.488L212.602 181.016L217.803 152.868L203.402 150.324Z",
    fill: "#FFDC84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 84",
    d: "M188.549 196.716L193.813 197.497",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 85",
    d: "M189.139 202.654L213.5 177.415",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 86",
    d: "M218.59 133.534L224.967 136.314",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 87",
    d: "M170.215 176.035C170.215 176.035 169.37 169.394 166.447 168.55",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 88",
    d: "M169.192 182.667C169.192 182.667 167.218 178.021 164.738 175.491",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.531 106.895C218.22 106.895 221.211 104.236 221.211 100.956C221.211 97.6763 218.22 95.0175 214.531 95.0175C210.841 95.0175 207.85 97.6763 207.85 100.956C207.85 104.236 210.841 106.895 214.531 106.895Z",
    fill: "#FFDC84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 90",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.545 97.3195C210.545 96.2316 213.821 95.0654 214.531 95.886C215.241 96.7066 214.579 98.612 212.921 98.9861C211.262 99.3601 210.545 98.4074 210.545 97.3195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 91",
    d: "M210.545 102.488C210.545 102.488 213.074 103.751 213.944 101.039C217.201 102.488 218.591 99.8826 218.591 99.8826",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 92",
    d: "M223.695 82.1148C223.695 82.1148 225.247 78.9444 228.426 78.9444",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 93",
    d: "M203.416 86.8826C203.416 86.8826 200.22 86.6463 199.254 87.9654",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 95",
    d: "M250.161 104.544C250.161 104.544 247.386 101.698 250.161 97.2444",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 97",
    d: "M210.543 118.26L210.075 112.009",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 98",
    d: "M193.186 119.125C193.186 119.125 196.715 121.049 196.715 125.642",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 100",
    d: "M317.456 222.474C317.456 222.474 317.067 225.956 320.672 227.501",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path 81"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.857 224.988C378.857 224.988 379.55 227.501 384.523 227.501L378.857 224.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.857 224.988C378.857 224.988 379.55 227.501 384.523 227.501",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 110",
    d: "M365.802 214.03L363.547 229.726",
    stroke: "#D6DCFF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 108",
    d: "M306.58 207.108L324.535 202.488",
    stroke: "#D6DCFF",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingSurvey);
export default __webpack_public_path__ + "static/media/OnboardingSurvey.341e28780353690e28ab285617c7371d.svg";
export { ForwardRef as ReactComponent };